import { render } from "./IconPickerDialog.vue?vue&type=template&id=23de867a&scoped=true"
import script from "./IconPickerDialog.vue?vue&type=script&lang=js"
export * from "./IconPickerDialog.vue?vue&type=script&lang=js"

import "./IconPickerDialog.vue?vue&type=style&index=0&id=23de867a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23de867a"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QInput,QCheckbox,QIcon});
